import {fonts} from '../../theme/foundations/fonts'
import {pxToRem} from '../../utills/pxToRem'
import colors from '../../theme/foundations/colors'

export const storeLocatorContent = {
    maxWidth: [pxToRem(335), pxToRem(335), pxToRem(758), pxToRem(758)],
    borderRadius: 0,
    marginTop: [pxToRem(170), pxToRem(170), pxToRem(180), pxToRem(180)],
    marginBottom: [pxToRem(170), pxToRem(170), pxToRem(180), pxToRem(180)],
    '.closeButton': {
        position: 'absolute',
        minWidth: pxToRem(20),
        height: pxToRem(20),
        top: pxToRem(20),
        right: pxToRem(20),
        opacity: 0.5,
        '&:hover': {
            opacity: 1
        },
        img: {
            width: pxToRem(20),
            height: pxToRem(20)
        }
    }
}

export const storeSelectorModalCloseButton = {
    height: pxToRem(15),
    weight: pxToRem(15),
    position: 'absolute',
    top: [pxToRem(11), pxToRem(11), pxToRem(20), pxToRem(20)],
    right: [pxToRem(-18), pxToRem(-18), pxToRem(0), pxToRem(0)]
}

export const storeSelectorContent = {
    borderRadius: 0
}

export const storeSelectorHeader = {
    padding: `${pxToRem(20)} ${pxToRem(20)}`,
    lineHeight: pxToRem(24),
    minHeight: pxToRem(70),
    h2: {
        fontFamily: fonts.primary,
        fontSize: [`${pxToRem(24)}`, `${pxToRem(24)}`, `${pxToRem(30)}`, `${pxToRem(30)}`],
        fontWeight: 600,
        letterSpacing: [pxToRem(0.68), pxToRem(0.68), pxToRem(0.78), pxToRem(0.78)],
        lineHeight: 1,
        textTransform: 'none',
        margin: 0
    }
}

export const storeSelectorFooter = {
    padding: `${pxToRem(20)}`,
    boxShadow: '0 -8px 8px 0 rgba(0, 0, 0, 0.1)',
    display: 'block',
    '.selectStoreError': {
        color: 'cav_dark_red',
        fontFamily: fonts.primary,
        letterSpacing: pxToRem(1),
        lineHeight: pxToRem(18),
        fontSize: pxToRem(12),
        fontWeight: 700,
        paddingTop: pxToRem(10),
        paddingBottom: pxToRem(20),
        margin: 0
    },
    '.selectStoreButton': {
        fontFamily: fonts.primary,
        fontSize: [`${pxToRem(12)}`, `${pxToRem(12)}`, `${pxToRem(12)}`, `${pxToRem(12)}`],
        fontWeight: 700,
        letterSpacing: pxToRem(1),
        lineHeight: pxToRem(18),
        textTransform: 'uppercase',
        width: '100%',
        paddingTop: [
            `${pxToRem(10.8)}`,
            `${pxToRem(10.8)}`,
            `${pxToRem(10.8)}`,
            `${pxToRem(10.8)}`
        ],
        paddingBottom: [
            `${pxToRem(10.8)}`,
            `${pxToRem(10.8)}`,
            `${pxToRem(10.8)}`,
            `${pxToRem(10.8)}`
        ],
        paddingLeft: [`${pxToRem(36)}`, `${pxToRem(36)}`, `${pxToRem(36)}`, `${pxToRem(36)}`],
        paddingRight: [`${pxToRem(36)}`, `${pxToRem(36)}`, `${pxToRem(36)}`, `${pxToRem(36)}`],
        backgroundColor: 'cav_dark_red',
        borderRadius: 0,
        '&:hover': {
            backgroundColor: 'cav_dark_red'
        }
    }
}

export const storeSelectorBody = {
    '.formSectionWrapper': {
        paddingBottom: pxToRem(20)
    },
    paddingBottom: pxToRem(0),
    paddingTop: pxToRem(0),
    paddingLeft: pxToRem(0),
    paddingRight: pxToRem(0),
    '.result': {
        fontFamily: fonts.primary,
        fontSize: [`${pxToRem(14)}`],
        fontWeight: 'bold',
        letterSpacing: 'normal',
        lineHeight: 1.2,
        textAlign: 'center',
        marginBottom: pxToRem(10),
        color: 'cav_dark_charcoal'
    },
    '.errorMessage': {
        color: 'red.cvs',
        fontFamily: fonts.primary,
        letterSpacing: 'normal',
        lineHeight: pxToRem(16.8),
        fontSize: pxToRem(14),
        fontWeight: 700,
        textTransform: 'uppercase',
        margin: 0,
        textAlign: 'center',
        padding: `${pxToRem(0)} ${pxToRem(20)} ${pxToRem(20)} ${pxToRem(20)}`
    }
}

export const storeSearchResultSection = {
    height: pxToRem(390),
    overflowY: 'scroll',
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: [pxToRem(10), pxToRem(10), pxToRem(20), pxToRem(20)],
    paddingRight: [pxToRem(10), pxToRem(10), pxToRem(20), pxToRem(20)],
    marginTop: pxToRem(10)
}

export const headerBar = {
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: `${pxToRem(1)} solid`,
    borderBottomColor: 'cav_black_variant'
}

export const resultHeader = {
    fontFamily: fonts.primary,
    fontSize: [`${pxToRem(14)}`],
    fontWeight: 700,
    letterSpacing: 'normal',
    lineHeight: pxToRem(18),
    paddingBottom: pxToRem(8),
    margin: 0,
    color: 'cav_dark_charcoal'
}

export const storeSelectorFormSection = {
    background: 'cav_faq_head_gray',
    marginTop: 0,
    marginBottom: 0,
    marginLeft: [pxToRem(10), pxToRem(10), pxToRem(20), pxToRem(20)],
    marginRight: [pxToRem(10), pxToRem(10), pxToRem(20), pxToRem(20)],
    padding: pxToRem(20),
    label: {
        fontFamily: fonts.primary,
        fontSize: [`${pxToRem(14)}`],
        fontWeight: '400',
        letterSpacing: 'normal',
        lineHeight: pxToRem(21),
        paddingBottom: pxToRem(6),
        color: 'cav_light_black',
        margin: 0
    },
    'input, select': {
        fontFamily: fonts.primary,
        border: `${pxToRem(1)} solid cav_light_black`,
        boxSizing: 'border-box',
        height: pxToRem(44),
        padding: `0 ${pxToRem(15)}`,
        width: '100%',
        borderRadius: 0,
        fontSize: [`${pxToRem(16)}`],
        fontWeight: 400,
        letterSpacing: 'normal',
        lineHeight: pxToRem(21),
        color: 'cav_light_black',
        backgroundColor: 'white',
        fontStyle: 'italic',
        '&:focus': {
            borderWidth: `${pxToRem(2)}`,
            borderColor: 'cav_blue',
            outline: 'none',
            boxShadow: 'none'
        },
        '&:hover': {
            border: `${pxToRem(1)} solid cav_light_black`
        },
        '&::placeholder': {
            color: 'cav_light_black'
        }
    },
    '.inputHasError': {
        fontWeight: 700,
        color: 'cav_dark_red'
    },
    '.orDivider': {
        fontFamily: fonts.primary,
        fontSize: [`${pxToRem(14)}`],
        fontWeight: 700,
        letterSpacing: 'normal',
        lineHeight: pxToRem(16.8),
        paddingTop: [pxToRem(13), pxToRem(13), pxToRem(13), pxToRem(13)],
        paddingBottom: [pxToRem(8), pxToRem(8), pxToRem(5), pxToRem(5)],
        margin: 0,
        color: 'black',
        textAlign: 'center'
    },
    '.stateCity': {
        paddingTop: [pxToRem(5)],
        display: 'flex',
        columnGap: pxToRem(10),
        '.state, .city': {
            width: '50%'
        }
    },
    '.findStoresButton': {
        width: '100%',
        borderRadius: 0,
        marginTop: pxToRem(10),
        borderWidth: pxToRem(2),
        borderColor: 'red.cvs',
        color: 'red.cvs',
        fontFamily: fonts.primary,
        letterSpacing: pxToRem(1),
        lineHeight: pxToRem(14.4),
        fontSize: [`${pxToRem(12)}`, `${pxToRem(12)}`, `${pxToRem(12)}`, `${pxToRem(12)}`],
        fontWeight: 700,
        '&:focus': {
            borderColor: 'cav_blue'
        },
        '&:active': {
            backgroundColor: 'transparent'
        }
    },
    '.inputError': {
        color: 'red.cvs',
        fontFamily: fonts.primary,
        letterSpacing: 'normal',
        lineHeight: pxToRem(18),
        fontSize: pxToRem(12),
        fontWeight: 700,
        marginTop: pxToRem(5)
    }
}

export const storeItem = {
    display: 'flex',
    paddingTop: [pxToRem(12), pxToRem(12), pxToRem(12), pxToRem(12)],
    paddingBottom: [pxToRem(12), pxToRem(12), pxToRem(12), pxToRem(12)],
    borderBottom: `${pxToRem(1)} solid ${colors.cav_gainsboro}`,
    '.defaultStoreLabel': {
        display: 'flex',
        alignItems: 'center',
        marginBottom: pxToRem(15)
    },
    '.defaultStoreLabel p': {
        fontFamily: fonts.primary,
        fontSize: [`${pxToRem(14)}`],
        fontWeight: 700,
        letterSpacing: pxToRem(1),
        lineHeight: pxToRem(21),
        margin: 0,
        marginLeft: pxToRem(15),
        color: 'cav_dark_charcoal'
    },
    '.radio': {
        '.chakra-radio__control[data-checked]': {
            background: 'none',
            backgroundColor: 'none',
            border: `${pxToRem(1)} solid`,
            borderColor: 'cav_charcoal'
        },
        '.chakra-radio__control[data-checked]::before': {
            backgroundColor: 'cav_charcoal',
            margin: `${pxToRem(3)} auto`,
            height: pxToRem(8),
            width: pxToRem(8)
        },
        span: {
            margin: 0,
            border: `${pxToRem(1)} solid`,
            borderColor: 'cav_charcoal'
        }
    },
    '.radioPdp': {
        width: '5%'
    },
    '.details': {
        paddingLeft: pxToRem(10),
        '.phoneNotForMobile': {
            display: ['none', 'block', 'block', 'block']
        },
        '.phoneForMobile': {
            display: ['block', 'none', 'none', 'none']
        },
        h3: {
            fontFamily: fonts.primary,
            fontSize: [`${pxToRem(14)}`, `${pxToRem(14)}`, `${pxToRem(14)}`, `${pxToRem(14)}`],
            fontWeight: 700,
            letterSpacing: 'normal',
            lineHeight: pxToRem(14),
            textTransform: 'none',
            marginTop: [pxToRem(2), pxToRem(2), pxToRem(2), pxToRem(2)],
            marginBottom: [pxToRem(15), pxToRem(15), pxToRem(15), pxToRem(15)],
            color: 'cav_dark_charcoal'
        },
        a: {
            fontFamily: fonts.primary,
            fontSize: [`${pxToRem(14)}`, `${pxToRem(14)}`, `${pxToRem(14)}`, `${pxToRem(14)}`],
            fontWeight: 500,
            letterSpacing: pxToRem(1),
            lineHeight: pxToRem(21),
            margin: 0,
            color: 'red.cvs',
            textDecoration: 'underline'
        },
        '.address': {
            paddingBottom: [pxToRem(6), pxToRem(6), pxToRem(6), pxToRem(6)],
            p: {
                fontFamily: fonts.primary,
                fontSize: [`${pxToRem(14)}`, `${pxToRem(14)}`, `${pxToRem(14)}`, `${pxToRem(14)}`],
                fontWeight: 500,
                letterSpacing: pxToRem(1),
                lineHeight: pxToRem(18.2),
                margin: 0,
                color: 'cav_dark_charcoal'
            }
        },
        '.chakra-accordion__item': {
            borderWidth: 0,
            paddingTop: pxToRem(12),
            h2: {
                margin: 0,
                button: {
                    fontFamily: fonts.primary,
                    padding: 0,
                    fontSize: [
                        `${pxToRem(14)}`,
                        `${pxToRem(14)}`,
                        `${pxToRem(14)}`,
                        `${pxToRem(14)}`
                    ],
                    fontWeight: 500,
                    letterSpacing: pxToRem(1),
                    lineHeight: pxToRem(18.2),
                    margin: 0,
                    color: 'red.cvs',
                    textDecoration: 'underline',
                    display: 'inline-block',
                    width: 'auto',
                    '&:focus': {
                        borderWidth: `${pxToRem(2)}`,
                        borderColor: 'cav_blue'
                    },
                    p: {
                        marginBottom: 0
                    }
                }
            }
        },
        '.chakra-accordion__panel': {
            padding: 0,
            table: {
                maxWidth: pxToRem(495),
                marginTop: pxToRem(15),
                tr: {
                    'td, th': {
                        borderWidth: 0,
                        paddingTop: pxToRem(5),
                        paddingBottom: pxToRem(5),
                        fontFamily: fonts.primary,
                        fontSize: [
                            `${pxToRem(14)}`,
                            `${pxToRem(14)}`,
                            `${pxToRem(14)}`,
                            `${pxToRem(14)}`
                        ],
                        fontWeight: 500,
                        letterSpacing: pxToRem(1),
                        lineHeight: pxToRem(16.8),
                        color: 'black'
                    },
                    th: {
                        fontWeight: 700,
                        letterSpacing: 'normal'
                    },
                    'td:nth-of-type(1), th:nth-of-type(1)': {
                        paddingLeft: pxToRem(0),
                        minWidth: [pxToRem(144), pxToRem(144), pxToRem(265), pxToRem(265)]
                    }
                }
            }
        }
    },
    '.detailsPdp': {
        width: '61%'
    },
    '.availableRow': {
        width: '34%'
    },
    '.availableBox': {
        display: 'flex',
        justifyContent: 'flex-end',
        fontFamily: fonts.primary,
        fontSize: [`${pxToRem(14)}`],
        fontWeight: 400,
        letterSpacing: 'normal',
        lineHeight: pxToRem(18.2),
        margin: 0,
        marginTop: [pxToRem(14)],
        marginLeft: pxToRem(5),
        textAlign: 'right',
        color: 'cav_dark_charcoal',
        img: {
            display: 'inline',
            marginRight: [pxToRem(3), pxToRem(3), pxToRem(3), pxToRem(3)],
            marginBottom: [pxToRem(3), pxToRem(3), pxToRem(3), pxToRem(3)]
        }
    },
    '.availableBox.notAvailable': {
        whiteSpace: 'nowrap'
    }
}
